// extracted by mini-css-extract-plugin
export default {"statistics-tasks__no-data":"StatisticsNoData_statistics-tasks__no-data__ngNl6"};